<template>
  <div style="width:100%;padding:10px;">
    <h1>{{ $t("archive.header") }}</h1>
    <v-layout row wrap v-if="l_tasks" style="margin:0;">
      <v-flex xs12 sm6 md4 lg3 v-for="n in 3" :key="n">
        <v-card outlined style="margin:5px;">
          <v-card-title>
            <v-skeleton-loader class="mx-auto" width="100%" type="heading"></v-skeleton-loader>
          </v-card-title>
          <v-card-text>
            <v-skeleton-loader
              class="mx-auto"
              width="100%"
              style="margin:0;"
              v-for="n in 3"
              :key="n"
              type="text"
            ></v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="!l_tasks && (tasks === undefined || tasks.length > 0)">
      <v-flex xs12 sm6 md4 lg3 v-for="task in tasks" :key="task.id">
        <TaskCard
          @edited="loadTasks"
          @putOnBottom="putOnBottom(task.id)"
          :id="task.id"
          :name="task.data.name"
          :interval="parseInt(task.data.interval)"
          :description="task.data.description"
        ></TaskCard>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { storage } from "./../schmucklicloud";

import TaskCard from "../components/TaskCard";

export default {
  data() {
    return {
      l_tasks: true,

      tasks: []
    };
  },
  mounted() {
    this.loadTasks();
  },
  methods: {
    async loadTasks() {
      var response = await storage.getAll("tasks");
      if (response.isOK) {
        this.tasks = response.data;
        this.tasks = this.tasks.filter(task => task.data.archived); // Filter the archived tasks.
        console.log(this.tasks);
      }
      this.l_tasks = false;
    },
    openAddTask() {
      this.$router.push("/add_task");
    },
    putOnBottom(task_id) {
      this.tasks.forEach(function(task, index) {
        if (task.id === task_id) {
          this.tasks[index].bottom = 1;
        }
      }.bind(this));
      this.tasks.sort(function (a, b) {
        if (a.bottom === undefined) {
          a.bottom = 0;
        }
        if (b.bottom === undefined) {
          b.bottom = 0;
        }

        if (a.bottom == b.bottom) {
          return a.id - b.id;
        }
        return a.bottom - b.bottom;
      });
    }
  },
  components: {
    TaskCard
  }
};
</script>

<style>
.mx-auto {
  margin-bottom: 30px;
}
</style>